
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Mumbaiairportcab() {



    const cardData =
    {
        keyword: 'Mumbai Airport Cab',
        heading: 'S9 Travels:  Mumbai Airport Cab',
        headingDescription: 'S9 Travels offers Mumbai Airport Cab Service, ensuring a comfortable, reliable, and hassle-free travel experience. Whether you need a cab for airport pickups, drop-offs, or transfers, our Innova cabs provide a smooth and timely ride. With spacious interiors, luxury features, and professional drivers, we guarantee on-time service and a stress-free journey. Enjoy affordable pricing, 24/7 availability, and easy booking. Choose S9 Travels for a seamless Mumbai Airport cab experience!',


        top: 'Top Places to Visit in Mumbai with S9 Travels',

"topPlaces": [
    {
      "title": "Gateway of India",
      "description": "A historic monument and one of Mumbai’s most iconic landmarks, the Gateway of India overlooks the Arabian Sea and is a popular tourist attraction."
    },
    {
      "title": "Marine Drive",
      "description": "Also known as the Queen’s Necklace, Marine Drive is a beautiful promenade along the Arabian Sea, perfect for evening strolls and enjoying the city’s skyline."
    },
    {
      "title": "Chhatrapati Shivaji Maharaj Terminus",
      "description": "A UNESCO World Heritage Site, this stunning railway station showcases Victorian Gothic architecture and is a symbol of Mumbai’s colonial past."
    },
    {
      "title": "Elephanta Caves",
      "description": "Located on Elephanta Island, these ancient rock-cut caves feature impressive sculptures and carvings dedicated to Lord Shiva. A ferry ride from Mumbai takes you to this UNESCO World Heritage Site."
    },
    {
      "title": "Siddhivinayak Temple",
      "description": "A famous temple dedicated to Lord Ganesha, Siddhivinayak Temple is visited by thousands of devotees and celebrities seeking blessings."
    },
    {
      "title": "Juhu Beach",
      "description": "One of Mumbai’s most popular beaches, Juhu Beach is known for its vibrant street food stalls, scenic views, and relaxed atmosphere."
    },
    {
      "title": "Colaba Causeway",
      "description": "A bustling shopping street in South Mumbai, Colaba Causeway is perfect for finding trendy clothes, accessories, and souvenirs."
    },
    {
      "title": "Haji Ali Dargah",
      "description": "Located on a small islet in the Arabian Sea, Haji Ali Dargah is a beautiful mosque and tomb, attracting both pilgrims and tourists."
    },
    {
      "title": "Sanjay Gandhi National Park",
      "description": "A green oasis in the middle of Mumbai, this national park offers trekking trails, wildlife spotting, and the famous Kanheri Caves."
    },
    {
      "title": "Bandra-Worli Sea Link",
      "description": "A modern architectural marvel, this cable-stayed bridge connects Bandra and Worli, offering spectacular views of Mumbai’s skyline."
    }
],

"services": [
    {
      "name": "Mumbai to Kolhapur Cab Service",
      "description": "S9 Travels offers reliable and comfortable cab services from Mumbai to Kolhapur. Whether you're traveling for business, leisure, or pilgrimage, our cabs ensure a safe and pleasant journey to Kolhapur."
    },
    {
      "name": "Book Mumbai to Kolhapur Taxi",
      "description": "Booking a taxi from Mumbai to Kolhapur is easy with S9 Travels. Choose from one-way or round-trip options and enjoy a comfortable ride with a professional driver."
    },
    {
      "name": "Mumbai to Kolhapur One-Way Cab",
      "description": "Planning a one-way trip from Mumbai to Kolhapur? S9 Travels provides convenient and affordable one-way cab services, ensuring a direct and hassle-free journey."
    },
    {
      "name": "Mumbai to Kolhapur Round Trip",
      "description": "S9 Travels offers round-trip cab services from Mumbai to Kolhapur, giving you the flexibility to explore Kolhapur and return comfortably."
    },
    {
      "name": "Affordable Mumbai to Kolhapur Cab",
      "description": "Looking for an affordable way to travel from Mumbai to Kolhapur? S9 Travels offers budget-friendly options without compromising on comfort, making your journey to Kolhapur easy on the wallet."
    },
    {
      "name": "Private Taxi for Kolhapur from Mumbai",
      "description": "Choose S9 Travels for a private taxi from Mumbai to Kolhapur. Enjoy a personalized and direct travel experience with professional drivers and a comfortable ride."
    },
    {
      "name": "Luxury Cab for Kolhapur Travel from Mumbai",
      "description": "Travel in style with S9 Travels' luxury cab service from Mumbai to Kolhapur. Experience premium amenities and exceptional comfort with our well-maintained luxury vehicles."
    },
    {
      "name": "Kolhapur Trip by Cab from Mumbai",
      "description": "Make your Kolhapur trip special with S9 Travels. Our well-maintained cabs and experienced drivers ensure a smooth and enjoyable journey from Mumbai to Kolhapur."
    },
    {
      "name": "Mumbai to Kolhapur Sightseeing Tour",
      "description": "Explore Kolhapur's famous landmarks with S9 Travels' sightseeing cab service. Our professional drivers will take you to the must-see attractions, making your visit to Kolhapur unforgettable."
    },
    {
      "name": "Group Travel to Kolhapur",
      "description": "Traveling with a group? S9 Travels provides spacious cabs for group travel from Mumbai to Kolhapur. Enjoy a comfortable and convenient ride for your entire group."
    },
    {
      "name": "Comfortable Taxi Service from Mumbai to Kolhapur",
      "description": "S9 Travels ensures a comfortable and relaxing taxi service from Mumbai to Kolhapur. Our experienced drivers and well-maintained vehicles ensure a pleasant and stress-free journey."
    }
],

"tableData": [
  ["Mumbai to Kolhapur Cab Service", "Book Mumbai to Kolhapur Taxi"],
  ["Mumbai to Kolhapur One-Way Cab", "Mumbai to Kolhapur Round Trip"],
  ["Affordable Mumbai to Kolhapur Cab", "Private Taxi for Kolhapur from Mumbai"],
  ["Luxury Cab for Kolhapur Travel from Mumbai", "Kolhapur Trip by Cab from Mumbai"],
  ["Mumbai to Kolhapur Sightseeing Tour", "Group Travel to Kolhapur"],
  ["Comfortable Taxi Service from Mumbai to Kolhapur", ""]
],






"whychoose": [
  {
    "WhyChooseheading": "Punctual and Reliable Airport Transfers",
    "WhyChoosedescription": "S9 Travels offers timely and reliable Mumbai airport cab services. Whether you’re catching a flight or arriving at Mumbai Airport, we ensure on-time pick-ups and drop-offs. Our professional drivers prioritize punctuality, so you never have to worry about missing your flight or waiting for your ride."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "Our fleet includes well-maintained, spacious vehicles, including the Toyota Innova, ensuring a comfortable ride to and from Mumbai Airport. With air conditioning, ample legroom, and a smooth ride, we ensure that your airport journey is as comfortable as possible."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "S9 Travels provides experienced and professional drivers who are familiar with Mumbai’s airport routes and traffic patterns. They ensure a safe and efficient journey, offering assistance as needed, to make your airport trip smooth and stress-free."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "We offer affordable and transparent pricing for our Mumbai airport cab services. Our pricing is clear with no hidden charges, so you can plan your airport trip without any surprises. We provide upfront cost breakdowns during the booking process."
  },
  {
    "WhyChooseheading": "Safety and Security for Your Airport Journey",
    "WhyChoosedescription": "Your safety is our top priority. Our cabs are equipped with modern safety features such as GPS tracking, airbags, and seat belts, ensuring that you travel securely to and from Mumbai Airport, whether you’re traveling alone or with family."
  },
  {
    "WhyChooseheading": "24/7 Availability for Airport Transfers",
    "WhyChoosedescription": "S9 Travels is available around the clock for your airport transportation needs. Whether it’s an early morning flight or a late-night arrival, we are ready to provide reliable cab services to and from Mumbai Airport at any time of the day or night."
  },
  {
    "WhyChooseheading": "Easy and Hassle-Free Booking",
    "WhyChoosedescription": "Booking your Mumbai Airport cab with S9 Travels is quick and easy. You can book online through our website or mobile app, or you can contact our customer service team for assistance. Our user-friendly booking process ensures a seamless experience."
  },
  {
    "WhyChooseheading": "Customizable Travel Options",
    "WhyChoosedescription": "We offer flexible and customizable options for your Mumbai airport journey. Whether you need a pick-up from your hotel, home, or office, or special arrangements for additional luggage, we can tailor the service to meet your exact needs."
  }
]














    }


    const faqData = [
        [
          {
            question: 'How can I book a cab to or from Mumbai Airport with S9 Travels?',
            answer: 'Booking a cab to or from Mumbai Airport is easy! You can book your ride through our website or app, or simply contact our customer service team for personalized assistance in arranging a comfortable airport transfer.',
          },
          {
            question: 'What types of vehicles are available for Mumbai Airport transfers?',
            answer: 'We offer a wide range of vehicles for your Mumbai Airport transfer, including sedans, SUVs, and premium vehicles like the Toyota Innova. Whether you’re traveling alone or with a group, we have the right vehicle to suit your needs.',
          },
          {
            question: 'How long does it take to travel from Mumbai Airport to the city?',
            answer: 'The time it takes to travel from Mumbai Airport to the city typically ranges from 30 minutes to an hour, depending on traffic. Our drivers are experienced in navigating Mumbai’s traffic and will ensure you reach your destination safely and on time.',
          },
          {
            question: 'Can I book a round trip from Mumbai Airport?',
            answer: 'Yes, we offer round-trip bookings for Mumbai Airport transfers. You can book your ride from the airport to your destination and then schedule your return trip to the airport according to your flight timings.',
          },
          {
            question: 'Do you provide pick-up services from both domestic and international terminals?',
            answer: 'Yes, we provide pick-up services from both the domestic and international terminals of Mumbai Airport. Just provide us with your flight details, and our driver will be waiting for you at the appropriate terminal.',
          },
          {
            question: 'Can I request a specific vehicle for my Mumbai Airport transfer?',
            answer: 'Yes, you can select the type of vehicle you would prefer for your Mumbai Airport transfer. Whether you need a sedan for a quick ride or an SUV for more comfort and space, we have a variety of options to meet your preferences.',
          },
          {
            question: 'How far in advance should I book my cab for Mumbai Airport?',
            answer: 'We recommend booking your Mumbai Airport cab at least 1-2 hours in advance, especially during peak travel times. However, you can also make last-minute bookings based on availability, and we will do our best to accommodate your request.',
          },
          {
            question: 'Is there an additional charge for waiting at the airport?',
            answer: 'There may be a small waiting charge if the driver needs to wait beyond the agreed time at the airport. However, this will be communicated upfront when you book your ride, ensuring full transparency in pricing.',
          },
          {
            question: 'Why should I choose S9 Travels for my Mumbai Airport cab service?',
            answer: 'S9 Travels offers reliable, comfortable, and hassle-free airport transfers. With well-maintained vehicles, professional drivers, and excellent customer service, we ensure you have a smooth and timely experience when traveling to or from Mumbai Airport.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Arvind Kapoor',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I used S9 Travels for my airport transfer to Mumbai Airport, and the experience was excellent! The driver was on time, the vehicle was comfortable, and the ride was smooth. I will definitely choose them for all my future airport trips!”',
        },
        {
          name: 'Mrs. Shweta Mehta',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“S9 Travels made my Mumbai Airport transfer so much easier. The driver was courteous, and the car was in great condition. I reached the airport comfortably and on time. Highly recommend them for anyone looking for reliable airport transfers!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Mumbai Airport Cab",
        "description": "Book affordable and reliable Mumbai airport cab services for pick-up, drop-off, and transfers. S9 Travels offers professional airport transportation, private taxi services, luxury transfers, and convenient shuttle options for both arrivals and departures at Mumbai Airport.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
     
      
      
      


    return (
        <div>
         <Helmet>
        <title>Mumbai Airport Cab | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Mumbai airport taxi services for pick-up, drop-off, and transfers. Affordable, reliable, and professional airport transportation options, including private taxis and luxury transfers for both arrivals and departures at Mumbai Airport with S9 Travels." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
      
     

<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/53.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaiairportcab;